// hooks
import { useQuery } from 'react-query';
import { getFlexMatchAskEmployeeMessage } from 'RestAPIs/flex-match';
import type { FlexMatchAskEmployeeMessagePayload } from 'RestAPIs/flex-match/types';

const useGetFlexMatchAskEmployeeMessage = (
  {
    workAgreementId,
    processInstanceId,
    employeeId,
    messageType
  }: FlexMatchAskEmployeeMessagePayload,
  options: Record<string, any> = {}
) => {
  return useQuery(
    [
      'flexMatchAskEmployeeMessage',
      workAgreementId,
      processInstanceId,
      employeeId,
      messageType
    ],
    async () => {
      const { data } = await getFlexMatchAskEmployeeMessage({
        workAgreementId,
        processInstanceId,
        employeeId,
        messageType
      });
      return data;
    },
    { ...options }
  );
};

export default useGetFlexMatchAskEmployeeMessage;
